<template>
  <div class="english-container">
    <h2>1. Erste Schritte</h2>
    <p style="text-align: left;">Um versehentliches Ausschalten zu verhindern, das dazu führen könnte, dass das Gerät nicht mehr lokalisiert werden kann, haben wir die Start- und Abschaltmethoden verbessert.</p>

    <h4>1.1 Ein-/Ausschalten</h4>
    <p style="text-align: left;">1.1.1 Einschalten: Halten Sie den runden Punkt auf dem Ein-/Ausschaltknopf des Geräts 3 Sekunden lang gedrückt. Wenn Sie einen Doppelton hören, ist das Gerät eingeschaltet. (Siehe Abbildung)</p>

    <img src="../assets/gid_1.png" alt="Wireless Tag Logo" class="image_1" />

    <p style="text-align: left;">
      1.1.2 Ausschalten: Drücken Sie den Geräteschalter zweimal, und Sie hören ein Bestätigungssignal. Danach drücken und halten Sie den Ein-/Ausschaltknopf für 3 Sekunden (wenn Sie ihn weniger oder länger als 3 Sekunden drücken, wird das Gerät nicht ausgeschaltet), dann <strong>lassen Sie los...</strong>, Sie hören zwei Pieptöne, die anzeigen, dass das Gerät ausgeschaltet ist.
    </p>
    <p style="text-align: left;">
      <strong>Hinweis: Die eingestellte Abschaltverzögerung wurde entwickelt, um versehentliches Ausschalten zu verhindern und sicherzustellen, dass das Gerät weiterhin effektiv lokalisieren kann.</strong>
    </p>

    <h4>1.2 Auf Updates prüfen</h4>
    <p style="text-align: left;">
      Um die Apple® Find My® App nutzen zu können, wird empfohlen, die neueste Version von iOS®, iPadOS® oder macOS® zu verwenden. Für die Find My App auf der Apple Watch wird die aktuellste Version von watchOS® benötigt.
    </p>

    <h3>2. Fügen Sie Ihren Locator hinzu</h3>
    <h4>2.1 App starten</h4>
    <p style="text-align: left;">2.1.1 Öffnen Sie die Find My App auf Ihrem unterstützten iPhone® oder iPad®.</p>
    <p style="text-align: left;">2.1.2 Erlauben Sie Benachrichtigungen der App.</p>

    <h4>2.2 Verbinden Ihres Locators</h4>
    <p style="text-align: left;">2.2.1 Schalten Sie Ihren Locator ein, wählen Sie die Registerkarte „Items“ und tippen Sie anschließend auf die Registerkarte „Add Item“, dann auf <strong>„Andere unterstützte Geräte“</strong>.</p>
    <p style="text-align: left;">2.2.2 Stellen Sie sicher, dass sich Ihr Item Locator in der Nähe Ihres Telefons befindet. Warten Sie... bis Sie die Meldung „Wireless tag“ sehen, und tippen Sie dann auf „Verbinden“.</p>
    <p style="text-align: left;">2.2.3 Wählen Sie einen erkennbaren Namen und Emoji für Ihren Item Locator aus und tippen Sie auf „Weiter“.</p>
    <p style="text-align: left;">2.2.4 Die Find My App fragt nach Bestätigung, Ihren Locator Ihrem Apple ID-Konto hinzuzufügen – tippen Sie auf „Weiter“.</p>
    <p style="text-align: left;">2.2.5 Tippen Sie auf „Fertig“. Der Locator ist nun eingerichtet und bereit, mit dem Gegenstand verbunden zu werden, den Sie lokalisieren möchten, z. B. Ihre Schlüssel.</p>

    <h3>3. Funktionsbeschreibung</h3>

    <h4>3.1 Lokalisation Ihres Gegenstands</h4>
    <p style="text-align: left;">Wenn sich Ihr Gegenstand in der Nähe befindet, tippen Sie auf „Ton abspielen“, um Ihren Locator piepsen zu lassen, dann finden Sie ihn. Ist er außerhalb der Reichweite, können Sie die letzte bekannte Position abrufen.</p>

    <h4>3.2 Benachrichtigungen</h4>
    <p style="text-align: left;">Sie erhalten eine Benachrichtigung, wenn Sie Ihren Locator zurückgelassen haben und er außerhalb der Reichweite Ihres Geräts ist.</p>
    <p style="text-align: left;"><strong>Hinweis:</strong> „Benachrichtigung bei Auffinden“ kann nur aktiviert werden, wenn sich der Locator außerhalb der Reichweite befindet.</p>

    <h4>3.3 Gegenstände teilen</h4>
    <p style="text-align: left;">Die Personen, mit denen Sie etwas geteilt haben, können es lokalisieren und erhalten keine Benachrichtigungen über ungeklärte Ortung.</p>
    <p style="text-align: left;">Um „Gegenstände teilen“ nutzen zu können, stellen Sie sicher, dass Sie und Ihre Freunde die öffentlichen Beta-Versionen von iOS 17, iPadOS 17 oder macOS 14 Sonoma oder neuere installiert haben.</p>

    <h4>3.4 Verlorenmodus</h4>
    <p style="text-align: left;">Wenn Ihr Gegenstand verloren gegangen ist, aktivieren Sie den Verlorenmodus. Sie erhalten eine Benachrichtigung, sobald die Position verfügbar ist. Sie können eine Telefonnummer oder E-Mail-Adresse hinterlassen, damit der Finder Sie kontaktieren kann.</p>
    <p style="text-align: left;"><strong>Hinweis:</strong> Sobald der „Verlorenmodus“ aktiviert ist, ist Ihr Locator gesperrt und niemand sonst kann sich damit verbinden. ENTFERNEN SIE DEN GEGENSTAND NICHT IN DER APP. Ihr Item Locator bleibt gesperrt und kann von niemandem genutzt werden.</p>

    <h4>3.5 Gegenstand entfernen</h4>
    <p style="text-align: left;">Stellen Sie sicher, dass sich der Gegenstand in Ihrer Nähe befindet, Sie können den Gegenstand in der App löschen. Es sollte einen Doppelpiepton geben, der anzeigt, dass der Gegenstand erfolgreich gelöscht wurde. Danach kann der Gegenstand von anderen Personen verwendet werden.</p>
    <p style="text-align: left;"><strong>Hinweis:</strong> Wenn der „Verlorenmodus“ aktiviert ist, entfernen Sie den Gegenstand NICHT in der App, andernfalls wird Ihr Locator gesperrt und niemand anders kann sich damit verbinden.</p>

    <h4>3.6 Werksreset durchführen</h4>
    <p style="text-align: left;">Wenn sich Ihr Gegenstand außerhalb der Reichweite Ihres Handys befindet und Ihr Locator aus der Find My App entfernt wurde, kann das Gerät von anderen Personen nicht mehr verwendet werden. Sie müssen Ihren Locator zurücksetzen, danach kann er wieder benutzt werden.</p>
    <p style="text-align: left;">So setzen Sie die Werkseinstellungen zurück: Drücken Sie den Funktionstaster zweimal, Sie hören einen Piepton. Danach drücken Sie den Funktionstaster viermal schnell hintereinander und halten ihn beim fünften Mal so lange gedrückt, bis Sie einen Doppelpiepton hören. Das Gerät ist jetzt zurückgesetzt. Das Gerät kann wie neu mit einem neuen Apple ID-Konto gekoppelt werden.</p>

    <h4>3.7 Erkennung unerwünschten Trackings</h4>
    <p style="text-align: left;">Wenn ein Find My Netzwerk-Zubehörteil vom Besitzer getrennt ist und sich im Laufe der Zeit mit Ihnen bewegt, erhalten Sie eine Benachrichtigung auf eine der beiden folgenden Arten: (1) Wenn Sie ein iPhone oder iPad besitzen, sendet Find My eine Benachrichtigung an Ihr Apple-Gerät. Diese Funktion steht unter iOS oder iPadOS 14.5 oder neuer zur Verfügung. (2) Wenn Sie kein iOS-Gerät oder Smartphone besitzen, gibt ein Find My Netzwerk-Zubehörteil, das sich längere Zeit nicht bei seinem Besitzer befindet, ein akustisches Signal ab, sobald es bewegt wird.</p>
    <p style="text-align: left;">Diese Funktion wurde extra entwickelt, um Menschen davon abzuhalten, Sie ohne Ihr Wissen zu verfolgen.</p>

    <h3>4. Technische Daten</h3>
    <ul>
      <li>Batterie: CR2032 3V (austauschbar)</li>
      <li>Arbeitsspannung: 2,8V–3,3V</li>
      <li>Kapazität: 220 mAh</li>
      <li>Drahtlosreichweite: 10–30 Meter</li>
      <li>Piepser: Max. 100 dB</li>
      <li>Produktmaße: φ32 × 7,9 mm</li>
    </ul>

    <h3>5. Tastenfunktionen</h3>
    <ol>
      <li style="text-align: left;">
        <strong>Einschalten (Find My-Funktion ist aktiv).</strong>
        <p>Drücken Sie den Funktionstaster 3 Sekunden lang, um das Gerät einzuschalten. Sie hören einen Doppelpiepton, der das Einschalten signalisiert.</p>
        <p>Falls das Produkt nicht mit Ihrer Apple ID verknüpft ist, schaltet es sich automatisch innerhalb von 10 Minuten ab. Sie müssen die Find My-Funktion erneut auslösen, um die Paarung fortzusetzen.</p>
      </li>
      <li style="text-align: left;">
        <strong>Ausschalten (Find My-Funktion ist deaktiviert).</strong>
        <p>Halten Sie den Funktionstaster drei Sekunden lang gedrückt, dann lassen Sie ihn los. Sie hören zwei Pieptöne, die das Ausschalten signalisieren.</p>
      </li>
      <li style="text-align: left;">
        <strong>Weitere Informationen abrufen aktivieren.</strong>
        <p>Drücken Sie den Funktionstaster zweimal rasch hintereinander, Sie hören ein Bestätigungssignal. Diese Aktion wird in der Find My App angezeigt, um die Person, die das Gerät erhält, dabei zu unterstützen, weitere Informationen zu erhalten, z. B. Kontaktdaten des Eigentümers (falls das Gerät im Verlorenmodus ist) und die Seriennummer des Geräts.</p>
      </li>
      <li style="text-align: left;">
        <strong>Werkseinstellungen wiederherstellen</strong>
        <p>Drücken Sie den Funktionstaster zweimal, Sie hören einen Piepton. Drücken Sie ihn viermal schnell hintereinander und halten Sie ihn beim fünften Mal solange gedrückt, bis Sie einen Doppelpiepton hören. Nun ist das Gerät zurückgesetzt.</p>
        <p>Ein Reset ist erforderlich, um das Gerät in den Koppelungsmodus zu bringen.</p>
      </li>
    </ol>

    <h3>6. Batterie- und Bandwechsel</h3>
    <ol>
      <li>Stecken Sie das Gehäuseöffnungswerkzeug in die Gehäusespaltöffnung.</li>
      <li>Drehen Sie das Gehäuseöffnungswerkzeug um 90 Grad, um das Gehäuse zu öffnen.</li>
      <li>Benutzen Sie Ihre Fingernägel am kleinen Spalt an der Seite Ihres Item Locators, um das Gehäuse vorsichtig zu öffnen.</li>
      <li>Ersetzen Sie die Batterie durch eine neue CR2032-Batterie mit 3 V Spannung. (Pluspol mit der Aufschrift nach oben).</li>
    </ol>

    <img src="../assets/open_tag.png" alt="Wireless Tag Logo" class="image_1" />
    <img src="../assets/open_tag_2.png" alt="Wireless Tag Logo" class="image_1" />

    <h3>FAQ</h3>
    <h4>1. Warum wird die Position meines Geräts nicht aktualisiert?</h4>
    <li style="text-align: left;">Es gibt zwei Prinzipien für die Positionsberichterstattung. Wenn viele Apple-Geräte in der Nähe sind, meldet jeder neue Nutzer in der Umgebung die Position, normalerweise innerhalb von 2–5 Minuten. Wenn sich das Gerät nicht bewegt hat, erkennt der eingebaute Sensor dies und das Gerät wechselt in den Ruhezustand, wobei die gemeldete Position zwischen 30 Minuten und mehreren Stunden liegen kann. Machen Sie sich keine Sorgen, die Position, die Sie sehen, stammt möglicherweise von vor 30 Minuten oder mehreren Stunden, aber es ist sehr wahrscheinlich, dass sich der Gegenstand nicht bewegt hat und die angezeigte Position die letzte bekannte ist.</li>

    <h4>2. Beim Koppeln eines Geräts mit der Find My App verbindet sich das Handy mit dem Apple Server. Die Verbindung kann aufgrund von Netzwerkproblemen fehlschlagen. Folgende Maßnahmen werden empfohlen:</h4>
    <ol>
      <li style="text-align: left;">Ändern Sie das Mobilfunknetz Ihres Smartphones, z. B. wechseln Sie zwischen WLAN und mobiler Verbindung. Die erste Kopplung kann lange dauern, bitte haben Sie etwas Geduld.</li>
      <li style="text-align: left;">Setzen Sie Ihr Gerät zurück.</li>
      <li style="text-align: left;">Reparatur über die Find My App.</li>
    </ol>

    <h3>Datenschutz & Sicherheit</h3>
    <p style="text-align: left; color:#333">Ihr Locator sendet ein sicheres Bluetooth-Signal, das von nahestehenden Geräten im Find My-Netzwerk erkannt werden kann. Diese Geräte leiten die Position Ihres Locators an iCloud weiter – danach können Sie die Find My App öffnen und die Position auf einer Karte ansehen. Der gesamte Prozess erfolgt anonym und verschlüsselt, um Ihre Privatsphäre zu schützen.</p>

    <h3>WARNUNG</h3>
    <ol>
      <li>Entfernen und entsorgen Sie gebrauchte Batterien gemäß den örtlichen Vorschriften und halten Sie diese von Kindern fern. Werfen Sie Batterien NICHT in Haushaltsabfall oder verbrennen Sie diese.</li>
      <li>Auch bereits verwendete Batterien können schwere Verletzungen oder gar Tod verursachen.</li>
      <li>Rufen Sie ein lokales Giftinformationszentrum für Behandlungsinformationen an.</li>
      <li>Nicht aufladbare Batterien dürfen nicht aufgeladen werden.</li>
      <li>Entladen, Aufladen, Zerlegen, Erhitzen über 50°C/122°F oder Verbrennen nicht zulassen.</li>
      <li>Dadurch können Verletzungen durch Entlüftung, Leckagen oder Explosionen entstehen, die chemische Verbrennungen auslösen können.</li>
      <li>Der kompatible Batterietyp ist CR2032.</li>
      <li>Die Nennspannung der Batterie beträgt DC 3V.</li>
      <li>Stellen Sie sicher, dass die Batterien korrekt entsprechend der Polarität (+ und -) eingebaut werden.</li>
      <li>Mischen Sie keine alten und neuen Batterien, verschiedene Marken oder Typen wie Alkaline-, Kohle-Zink- oder Akkubatterien.</li>
      <li>Entfernen und entsorgen Sie Batterien von Geräten, die für einen längeren Zeitraum nicht verwendet wurden, sofort gemäß den örtlichen Vorschriften.</li>
      <li>Verschließen Sie immer vollständig das Batteriefach. Falls das Batteriefach nicht sicher geschlossen werden kann, beenden Sie die Nutzung des Produkts, entfernen Sie die Batterien und halten Sie sie von Kindern fern.</li>
    </ol>

    <h5>
      <p>Batterietyp: CR2032. Batteriespannung: 3V.</p>
      <p>Lassen Sie die Batterie in der Originalverpackung, bis Sie sie benötigen;</p>
      <p>Entsorgen Sie gebrauchte Batterien sofort und halten Sie sie von Kindern fern. Werfen Sie Batterien NIEMALS in Haushaltsabfall.</p>
    </h5>

    <img src="../assets/image_battery.png" class="image_1" />
  </div>
</template>

<script>
export default {
  name: 'IosDeutsch',
};
</script>

<style scoped>
.english-container {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px;
  margin: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h1, h2,h3,h4,h5 {
  color: #333;
 text-align: left; /* 明确标题左对齐（如果父级未继承） */

}
ul, ol {
  margin-left: 20px;
  padding-left: 15px;
 list-style-type: decimal; /* 强制显示数字编号 */

}
li {
  margin-bottom: 8px;
  text-align: left;
  color: #000000;
}

.image_1 {
  width: 90%; /* 或根据需要调整 */
  height: auto;
  margin-bottom: 10px;
  border-radius: 8px;
}

</style>